import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { AuthService } from '../../../services/auth.service';
import { environment } from '../../../../environments/environment';

export interface Localizacao {
  localizacaoId: string;
  latitude: string;
  longitude: string;
  dataHora: string;
  precisao: number;
}

@Injectable({
  providedIn: 'root'
})
export class RoteiroUsuarioService {

  private apiUrl = `${environment.controllApp}`;
  
  constructor(private http: HttpClient, private authService: AuthService) {}

  /**
   * Retorna apenas as localizações do usuário
   * @param usuarioId UUID do usuário
   */
  obterLocalizacoesPorUsuario(usuarioId: string): Observable<Localizacao[]> {
    const url = `${this.apiUrl}/usuario/${usuarioId}/historico-completo`;
    const token = this.authService.getToken();
    const headers = token ? new HttpHeaders({
      Authorization: `Bearer ${token}`
    }) : undefined;

    return this.http.get<any>(url, { headers }).pipe(
      map(response => {
        const locs = response?.localizacoes || [];
        const safeParse = (s: any) => {
          const t = Date.parse(s);
          return isNaN(t) ? 0 : t;
        };
        return locs.slice().sort((a: any, b: any) => safeParse(a?.dataHora) - safeParse(b?.dataHora));
      })
    );
  }
}
